
import {
    DialogPositioningBehavior, DialogProps,
    DialogType, DialogWidget, InlineAlertType,
    InlineAlertWidget, ToggleSwitchWidget
} from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { Broadcasts } from '../resources/Broadcasts';


export const BROADCAST_VIEW_DIALOG_TESTID = 'broadcast-view-dialog';

export class BroadcastViewDetailDialog extends React.PureComponent<BroadcastViewDetailDialogProps, BroadcastViewDetailDialogStates> {

    constructor(props: BroadcastViewDetailDialogProps) {
        super(props);
        this.state = {
            isBroadcast: false,
            publishInProgress: false,
        };
    }

    public render() {
        const props: DialogProps = {
            onCloseRequest: this.props.onCloseRequest,
            isModal: true,
            type: DialogType.NormalWithTitleBar,
            testId: 'modal-broadcastdetail-pane',
            showCloseButton: false,
            positioningBehavior: DialogPositioningBehavior.Centered,
            title: Messages.broadcast(),
        };
        const WrapperStyle: React.CSSProperties = {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            paddingBottom: 10
        };

        return (
            <DialogWidget {...props}
                dialogWidth={502}
                showCloseButton
                onCloseRequest={props.onCloseRequest}
            >
                <p>{Messages.broadcastViewDialogDetails()}</p>
                <div style={WrapperStyle}>
                    <ToggleSwitchWidget
                        textAlign='right'
                        onChange={this.handleToggleBroadcast}
                        checked={this.state.isBroadcast}
                        testId={`${BROADCAST_VIEW_DIALOG_TESTID}-close`}
                        children={Messages.broadcastToggleLabel()}
                    />
                </div>
                {this.triggerBroadcastInProgressAlert(this.state.publishInProgress)}
            </DialogWidget>);
    }

    public async componentDidMount() {
        try {
            const broadcastDetail = await Broadcasts.getDetailOfABroadcast(this.props.viewLuid);
            if (broadcastDetail) {
                this.setState({
                    isBroadcast: true
                });
            } else {
                this.handleError();
            }
        } catch (e) {
            this.handleError(e);
        }
    }

    private handleError(errors?: any) {
        // TODO: customize error msg and Pop error
    }

    private triggerBroadcastInProgressAlert = (publishInProgress: boolean): JSX.Element => {
        if (!publishInProgress) {
            return null;
        }
        return (
            <InlineAlertWidget
                children={<span>{Messages.broadcastInProgressInfo()}</span>}
                type={InlineAlertType.Info}
                testId=''
            />
        );
    };

    private handleToggleBroadcast = () => {
        this.state.isBroadcast? this.props.onDeleteBroadcast() : this.props.onCreateBroadcast();
        this.setState({
            isBroadcast: !this.state.isBroadcast,
            publishInProgress: true
        });
    };
}

export interface BroadcastViewDetailDialogProps {
    readonly viewLuid: string;
    onCloseRequest: () => void;
    onCreateBroadcast: () => void;
    onDeleteBroadcast: () => void;
}

export interface BroadcastViewDetailDialogStates {
    isBroadcast: boolean;
    publishInProgress: boolean;
}